export const version: string = "15.5.42";
